export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1] } },
};

export const fadeRight = {
  hidden: { opacity: 0, x: -28 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

export const stagger = {
  visible: { transition: { staggerChildren: 0.1 } },
};

export const heroImageMotion = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 },
  transition: { duration: 0.6 },
};

export const viewportOnce = { once: true, amount: 0 };
export const viewportOnceSmall = { once: true, amount: 0 };
export const viewportOnceOnly = { once: true };

export const statItemInitial = { opacity: 0, y: 20 };
export const statItemAnimate = { opacity: 1, y: 0 };
export const slideFromRight = {
  initial: { opacity: 0, x: 30 },
  whileInView: { opacity: 1, x: 0 },
  transition: { duration: 0.5 },
};

export const statItemTransition = { duration: 0.5 };

// SnowballGraph animation constants
export const springStiff = { type: "spring", stiffness: 200, damping: 20 };
export const springMedium = { type: "spring", stiffness: 150, damping: 20 };
export const fadeShort = { duration: 0.3 };
export const springBounce = { type: "spring", bounce: 0.4 };
export const springBounceDelay1 = { type: "spring", bounce: 0.4, delay: 0.1 };
export const springBounceDelay2 = { type: "spring", bounce: 0.4, delay: 0.2 };

// PricingPage pulse animation
export const pulseScale = { scale: [1, 1.05, 1] };
export const pulseTransition = { repeat: Infinity, duration: 2, ease: "easeInOut" };

// Shared hover/tap interactions
export const hoverLiftSmall = { y: -4, transition: { type: "spring", stiffness: 400 } };
export const hoverLiftMedium = { y: -6, transition: { type: "spring", stiffness: 400 } };
export const hoverLiftCard = { y: -6, transition: { type: "spring", stiffness: 300 } };
export const tapScale = { scale: 0.98 };
export const tapScaleSmall = { scale: 0.95 };